<div
    class="p-3 pt-0 min-login-size"
    style="position: absolute; align-self: auto;"
    [ngStyle]="{ 'min-width': isBillingTheSameAsTrading ? '50%' : '65%' }"
>
    <div class="login-logo"></div>
    <mat-card>
        <mat-card-header>
            <mat-card-title class="mt-4">Sign-up</mat-card-title>
            <mat-card-subtitle
                >Please enter your details to complete signing
                up.</mat-card-subtitle
            >
        </mat-card-header>

        <form [formGroup]="signupForm" (ngSubmit)="onSubmit()">
            <mat-card-content>
                <div class="row">
                    <div
                        [ngClass]="
                            isBillingTheSameAsTrading
                                ? 'col-md-6'
                                : 'col-md-12 col-xl-4'
                        "
                    >
                        <div class="row">
                            <h3 class="col-12">Company Details</h3>
                        </div>

                        <mat-form-field>
                            <input
                                type="text"
                                [ngClass]="{
                                    'is-invalid':
                                        submitted && f.company_name.errors
                                }"
                                matInput
                                placeholder="Company Name"
                                formControlName="company_name"
                                autocomplete="organization"
                            />
                            @if (submitted && f.company_name.errors) {
                            <div class="invalid-feedback">
                                @if (f.company_name.errors.required) {
                                <div>
                                    Company Name is required.
                                </div>
                                }
                            </div>
                            }
                        </mat-form-field>

                        <mat-form-field>
                            <input
                                type="text"
                                [ngClass]="{
                                    'is-invalid':
                                        submitted && f.billing_email.errors
                                }"
                                matInput
                                placeholder="Billing Email"
                                formControlName="billing_email"
                                autocomplete="organization"
                            />
                            @if (submitted && f.billing_email.errors) {
                            <div class="invalid-feedback">
                                @if (f.billing_email.errors.required) {
                                <div>
                                    Billing email is required.
                                </div>
                                }
                            </div>
                            }
                        </mat-form-field>

                        <div class="row">
                            <h3 class="col-12">User Details</h3>
                        </div>

                        <mat-form-field>
                            <input
                                type="text"
                                [ngClass]="{
                                    'is-invalid': submitted && f.name.errors
                                }"
                                matInput
                                placeholder="Full Name"
                                formControlName="name"
                                autocomplete="name"
                            />
                            @if (submitted && f.name.errors) {
                            <div class="invalid-feedback">
                                @if (f.name.errors.required) {
                                <div>
                                    Full Name is required.
                                </div>
                                }
                            </div>
                            }
                        </mat-form-field>

                        <mat-form-field>
                            <input
                                type="text"
                                [ngClass]="{
                                    'is-invalid': submitted && f.email.errors
                                }"
                                matInput
                                placeholder="Email"
                                formControlName="email"
                                autocomplete="email"
                            />
                            @if (submitted && f.email.errors) {
                            <div class="invalid-feedback">
                                @if (f.email.errors.required) {
                                <div>
                                    Email is required.
                                </div>
                                } @if (f.email.errors.email) {
                                <div>
                                    Please enter a valid email address.
                                </div>
                                }
                            </div>
                            }
                        </mat-form-field>

                        <mat-form-field>
                            <input
                                type="text"
                                [ngClass]="{
                                    'is-invalid': submitted && f.phone.errors
                                }"
                                matInput
                                placeholder="Phone Number"
                                formControlName="phone"
                                autocomplete="phone"
                            />
                            @if (submitted && f.phone.errors) {
                            <div class="invalid-feedback">
                                @if (f.phone.errors.required) {
                                <div>
                                    Phone Number is required.
                                </div>
                                }
                            </div>
                            }
                        </mat-form-field>

                        <mat-form-field>
                            <input
                                type="password"
                                [ngClass]="{
                                    'is-invalid': submitted && f.password.errors
                                }"
                                matInput
                                placeholder="Password"
                                formControlName="password"
                                autocomplete="current-password"
                            />
                            @if (submitted && f.password.errors) {
                            <div class="invalid-feedback">
                                @if (f.password.errors.required) {
                                <div>
                                    Password is required.
                                </div>
                                }
                            </div>
                            }
                        </mat-form-field>

                        <mat-form-field>
                            <input
                                type="password"
                                [ngClass]="{
                                    'is-invalid':
                                        submitted &&
                                        f.password_confirmation.errors
                                }"
                                matInput
                                placeholder="Confirm Password"
                                formControlName="password_confirmation"
                                autocomplete="current-password"
                            />
                            @if (submitted && f.password_confirmation.errors) {
                            <div class="invalid-feedback">
                                @if (f.password_confirmation.errors.required) {
                                <div>
                                    Confirm Password is required.
                                </div>
                                }
                            </div>
                            }
                        </mat-form-field>
                    </div>

                    <div
                        [ngClass]="
                            isBillingTheSameAsTrading
                                ? 'col-md-6'
                                : 'col-md-12 col-xl-4'
                        "
                    >
                        <form formGroupName="billing_address">
                            <div class="row">
                                <h3 class="col-12 col-md-5">Billing Address</h3>
                                <mat-checkbox
                                    class="col-12 col-md-7 text-right"
                                    color="primary"
                                    (change)="differentTradingAddress()"
                                    >Different Trading Address?
                                </mat-checkbox>
                            </div>

                            <mat-form-field>
                                <mat-label>Address 1</mat-label>
                                <input
                                    matInput
                                    type="text"
                                    formControlName="address_line_1"
                                    required
                                />
                            </mat-form-field>
                            @if
                            (signupForm.get('billing_address.address_line_1').errors
                            &&
                            (signupForm.get('billing_address.address_line_1').dirty
                            ||
                            signupForm.get('billing_address.address_line_1').touched)
                            ) {
                            <div class="text-danger">
                                @if
                                (signupForm.get('billing_address.address_line_1').errors.required)
                                {
                                <div padding>
                                    *Please enter Address 1.
                                </div>
                                }
                            </div>
                            }

                            <mat-form-field>
                                <mat-label>Address 2</mat-label>
                                <input
                                    matInput
                                    type="text"
                                    formControlName="address_line_2"
                                />
                            </mat-form-field>
                            <!-- <div class="text-danger"
              ngIf="signupForm.get('billing_address.address_line_2').errors && (signupForm.get('billing_address.address_line_2').dirty || signupForm.get('billing_address.address_line_2').touched) ">
              <div ngIf="signupForm.get('billing_address.address_line_2').errors.required" padding>
                *Please enter Address 2.
              </div>
            </div> -->

                            <mat-form-field>
                                <mat-label>Address 3</mat-label>
                                <input
                                    matInput
                                    type="text"
                                    formControlName="address_line_3"
                                />
                            </mat-form-field>
                            <!-- <div class="text-danger"
            ngIf="signupForm.get('billing_address.address_line_3').errors && (signupForm.get('billing_address.address_line_3').dirty || signupForm.get('billing_address.address_line_3').touched) ">
            <div ngIf="signupForm.get('billing_address.address_line_3').errors.required" padding>
              *Please enter Address 3.
            </div>
          </div> -->

                            <mat-form-field>
                                <mat-label>Postcode</mat-label>
                                <input
                                    matInput
                                    type="text"
                                    formControlName="postcode"
                                    (input)="
                                        forceUppercaseConditionally(
                                            'billing_address',
                                            'postcode',
                                            $event
                                        )
                                    "
                                    required
                                />
                            </mat-form-field>
                            @if
                            (signupForm.get('billing_address.postcode').errors
                            && (signupForm.get('billing_address.postcode').dirty
                            ||
                            signupForm.get('billing_address.postcode').touched)
                            ) {
                            <div class="text-danger">
                                @if
                                (signupForm.get('billing_address.postcode').errors.required)
                                {
                                <div padding>
                                    *Please enter postcode.
                                </div>
                                }
                            </div>
                            }

                            <mat-form-field>
                                <mat-label>Locality / City</mat-label>
                                <input
                                    matInput
                                    type="text"
                                    formControlName="locality"
                                />
                            </mat-form-field>
                            <!-- <div class="text-danger"
          ngIf="signupForm.get('billing_address.locality').errors && (signupForm.get('billing_address.locality').dirty || signupForm.get('billing_address.locality').touched) ">
          <div ngIf="signupForm.get('billing_address.locality').errors.required" padding>
            *Please enter locality / city.
          </div>
        </div> -->

                            <mat-form-field>
                                <mat-label>County</mat-label>
                                <input
                                    matInput
                                    type="text"
                                    formControlName="county"
                                />
                            </mat-form-field>
                            <!-- <div class="text-danger"
        ngIf="signupForm.get('billing_address.county').errors && (signupForm.get('billing_address.county').dirty || signupForm.get('billing_address.county').touched) ">
        <div ngIf="signupForm.get('billing_address.county').errors.required" padding>
          *Please enter County.
        </div>
      </div> -->

                            <mat-form-field>
                                <mat-label>Country</mat-label>
                                <mat-select formControlName="country" required>
                                    <mat-option>
                                        <ngx-mat-select-search
                                            placeholderLabel="Search for Countries"
                                            noEntriesFoundLabel="No matching country found"
                                            (keyup)="
                                                searchBillingCountries($event)
                                            "
                                        ></ngx-mat-select-search>
                                    </mat-option>
                                    @for (country of billingCountrySearch; track
                                    country) {
                                    <mat-option [value]="country"
                                        ><img
                                            style="max-width: 20px; margin-right: 5px;"
                                            [src]="country.flags.png"
                                        />
                                        {{
                                            country.name.common | titlecase
                                        }}</mat-option
                                    >
                                    }
                                </mat-select>
                            </mat-form-field>
                            <!-- <div class="text-danger"
      ngIf="signupForm.get('billing_address.country').errors && (signupForm.get('billing_address.country').dirty || signupForm.get('billing_address.country').touched) ">
      <div ngIf="signupForm.get('billing_address.country').errors.required" padding>
        *Please enter Country.
      </div>
    </div> -->
                        </form>
                    </div>

                    <div
                        [ngClass]="
                            isBillingTheSameAsTrading
                                ? 'col-md-6'
                                : 'col-md-12 col-xl-4'
                        "
                    >
                        @if (!isBillingTheSameAsTrading) {
                        <form formGroupName="trading_address">
                            <div class="row">
                                <h3 class="col-12">Trading Address</h3>
                            </div>
                            <mat-form-field>
                                <mat-label>Address 1</mat-label>
                                <input
                                    matInput
                                    type="text"
                                    formControlName="address_line_1"
                                    required
                                />
                            </mat-form-field>
                            @if
                            (signupForm.get('trading_address.address_line_1').errors
                            &&
                            (signupForm.get('trading_address.address_line_1').dirty
                            ||
                            signupForm.get('trading_address.address_line_1').touched)
                            ) {
                            <div class="text-danger">
                                @if
                                (signupForm.get('trading_address.address_line_1').errors.required)
                                {
                                <div padding>
                                    *Please enter Address 1.
                                </div>
                                }
                            </div>
                            }
                            <mat-form-field>
                                <mat-label>Address 2</mat-label>
                                <input
                                    matInput
                                    type="text"
                                    formControlName="address_line_2"
                                />
                            </mat-form-field>
                            <!-- <div class="text-danger"
      ngIf="signupForm.get('trading_address.address_line_2').errors && (signupForm.get('trading_address.address_line_2').dirty || signupForm.get('trading_address.address_line_2').touched) ">
      <div ngIf="signupForm.get('trading_address.address_line_2').errors.required" padding>
        *Please enter Address 2.
      </div>
    </div> -->
                            <mat-form-field>
                                <mat-label>Address 3</mat-label>
                                <input
                                    matInput
                                    type="text"
                                    formControlName="address_line_3"
                                />
                            </mat-form-field>
                            <!-- <div class="text-danger"
    ngIf="signupForm.get('trading_address.address_line_3').errors && (signupForm.get('trading_address.address_line_3').dirty || signupForm.get('trading_address.address_line_3').touched) ">
    <div ngIf="signupForm.get('trading_address.address_line_3').errors.required" padding>
      *Please enter Address 3.
    </div>
  </div> -->
                            <mat-form-field>
                                <mat-label>Postcode</mat-label>
                                <input
                                    matInput
                                    type="text"
                                    formControlName="postcode"
                                    (input)="
                                        forceUppercaseConditionally(
                                            'trading_address',
                                            'postcode',
                                            $event
                                        )
                                    "
                                    required
                                />
                            </mat-form-field>
                            @if
                            (signupForm.get('trading_address.postcode').errors
                            && (signupForm.get('trading_address.postcode').dirty
                            ||
                            signupForm.get('trading_address.postcode').touched)
                            ) {
                            <div class="text-danger">
                                @if
                                (signupForm.get('trading_address.postcode').errors.required)
                                {
                                <div padding>
                                    *Please enter postcode.
                                </div>
                                }
                            </div>
                            }
                            <mat-form-field>
                                <mat-label>Locality / City</mat-label>
                                <input
                                    matInput
                                    type="text"
                                    formControlName="locality"
                                />
                            </mat-form-field>
                            <!-- <div class="text-danger"
  ngIf="signupForm.get('trading_address.locality').errors && (signupForm.get('trading_address.locality').dirty || signupForm.get('trading_address.locality').touched) ">
  <div ngIf="signupForm.get('trading_address.locality').errors.required" padding>
    *Please enter locality / city.
  </div>
</div> -->
                            <mat-form-field>
                                <mat-label>County</mat-label>
                                <input
                                    matInput
                                    type="text"
                                    formControlName="county"
                                />
                            </mat-form-field>
                            <!-- <div class="text-danger"
ngIf="signupForm.get('trading_address.county').errors && (signupForm.get('trading_address.county').dirty || signupForm.get('trading_address.county').touched) ">
<div ngIf="signupForm.get('trading_address.county').errors.required" padding>
  *Please enter County.
</div>
</div> -->
                            <mat-form-field>
                                <mat-label>Country</mat-label>
                                <mat-select formControlName="country" required>
                                    <mat-option>
                                        <ngx-mat-select-search
                                            placeholderLabel="Search for Countries"
                                            noEntriesFoundLabel="No matching country found"
                                            (keyup)="
                                                searchTradingCountries($event)
                                            "
                                        ></ngx-mat-select-search>
                                    </mat-option>
                                    @for (country of tradingCountrySearch; track
                                    country) {
                                    <mat-option [value]="country"
                                        ><img
                                            style="max-width: 20px; margin-right: 5px;"
                                            [src]="country.flags.png"
                                        />
                                        {{
                                            country.name.common | titlecase
                                        }}</mat-option
                                    >
                                    }
                                </mat-select>
                            </mat-form-field>
                            <!-- <div class="text-danger"
ngIf="signupForm.get('trading_address.country').errors && (signupForm.get('trading_address.country').dirty || signupForm.get('trading_address.country').touched) ">
<div ngIf="signupForm.get('trading_address.country').errors.required" padding>
  *Please enter Country.
</div>
</div> -->
                        </form>
                        }
                    </div>
                </div>

                <div class="col-12 mt-3">
                    @if (error) {
                    <div class="alert alert-danger mt-1">{{ error }}</div>
                    }
                </div>
            </mat-card-content>

            <mat-card-actions class="m-0">
                <button
                    type="submit"
                    mat-raised-button
                    color="primary"
                    [disabled]="loading"
                >
                    @if (loading) {
                    <mat-icon>
                        <mat-spinner diameter="20"></mat-spinner>
                    </mat-icon>
                    } @if (!loading) {
                    <span>Submit</span>
                    }
                </button>
                <a mat-button color="primary" routerLink="/login"
                    >Return to login</a
                >
            </mat-card-actions>
        </form>
    </mat-card>
</div>
